"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _input = _interopRequireDefault(require("../../../../core/input"));
var _formatDateRange = _interopRequireDefault(require("../../../../../utils/formatDateRange"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const initialState = {
  cancellationRequested: false,
  isProcessing: false,
  confirmed: false,
  errorMessage: null
};
var _ref = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Payouts of funds have already been started for your competition, so you cannot use this function to cancel."), /*#__PURE__*/_react.default.createElement("p", null, "This may be due to the competition being rescheduled after payments had been charged to the paddlers"), /*#__PURE__*/_react.default.createElement("p", null, "You will need to:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Send paddlers an email to tell them of the cancellation (use the group email function on the completed entries page"), /*#__PURE__*/_react.default.createElement("li", null, "Individually cancel and refund all the entries placed ", /*#__PURE__*/_react.default.createElement("emp", null, "after"), " rescheduling (using the cancel button on the completed entries page"), /*#__PURE__*/_react.default.createElement("li", null, "refund those who entered before rescheduling using cheques")));
var _ref2 = /*#__PURE__*/_react.default.createElement("p", null, "This will:");
var _ref3 = /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Send an email to all accepted entries (this includes any postal entries with a contact email address)."), /*#__PURE__*/_react.default.createElement("li", null, "Cancel all the entries in the competition."), /*#__PURE__*/_react.default.createElement("li", null, "Refund all the online entries."));
var _ref4 = /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "This cannot be undone!!");
class CancelCompetition extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onToggleRequest", () => {
      if (this.state.cancellationRequested) return this.setState(initialState);
      this.setState({
        cancellationRequested: true
      });
    });
    _defineProperty(this, "_onToggleConfirm", () => {
      this.setState({
        confirmed: !this.state.confirm
      });
    });
    _defineProperty(this, "_onCancelCompetition", () => {
      if (this.state.isProcessing) return;
      this.setState({
        isProcessing: true
      });
      return this.props.onCancelCompetition().then(result => {
        if (result && !result.success) {
          this.setState({
            errorMessage: result.message
          });
          return this.setState({
            isProcessing: false
          });
        }
        return this.setState(initialState);
      });
    });
  }
  render() {
    const today = new Date().toISOString().split('T')[0];
    const competition = this.props.competition;
    const modalButtons = competition.payouts && competition.payouts.length ? /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this._onToggleRequest
    }, "Close") : /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this._onToggleRequest
    }, "Oops! No! Don't cancel!"), this.state.errorMessage ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      disabled: !this.state.confirmed || this.state.isProcessing,
      loading: this.state.isProcessing,
      onClick: this._onCancelCompetition
    }, "Cancel Competition"));
    return /*#__PURE__*/_react.default.createElement("div", null, competition.isCancelled || competition.startDate < today ? null : /*#__PURE__*/_react.default.createElement("div", {
      className: "pull-md-right"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onToggleRequest,
      size: "sm"
    }, "Cancel Competition"), !this.state.cancellationRequested ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: 'Cancel ' + competition.competitionName + ' on ' + (0, _formatDateRange.default)(competition.competitionDays.map(d => d.dayDate)),
      onClose: this._onToggleRequest,
      buttons: modalButtons
    }, this.state.errorMessage ? /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, this.state.errorMessage) : competition.payouts && competition.payouts.length ? _ref : /*#__PURE__*/_react.default.createElement("div", null, _ref2, _ref3, _ref4, /*#__PURE__*/_react.default.createElement(_alert.default, {
      type: "danger"
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      checked: this.state.confirmed,
      onChange: this._onToggleConfirm,
      label: 'Yes, I confirm that I want to permanently cancel ' + competition.competitionName + ' on ' + (0, _formatDateRange.default)(competition.competitionDays.map(d => d.dayDate))
    }))))));
  }

  // *******************************************************************************
  // PartialQuery definition
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CancelCompetition, "partialQueries", {
  Competition: {
    id: true,
    competitionName: true,
    isCancelled: true,
    startDate: true,
    payouts: {
      id: true
    },
    competitionDays: {
      dayDate: true
    }
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(CancelCompetition, undefined, (client, props) => ({
  onCancelCompetition() {
    return client.update('Competition.cancelCompetition', {
      competitionID: props.competition.id
    });
  }
}));